<div class="shopping-cart-dialog">
  <!-- Header -->
  <div class="bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] px-6 py-4">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
          <mat-icon class="!text-white !text-2xl">shopping_cart</mat-icon>
        </div>
        <h2 class="text-2xl font-bold text-white">Shopping Cart</h2>
        <span class="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-bold">
          {{ cartItems.length }} item{{ cartItems.length !== 1 ? 's' : '' }}
        </span>
      </div>
      <button type="button" mat-icon-button (click)="close()" class="!text-white hover:!bg-white/20">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Cart Items -->
  <div class="p-6 max-h-[60vh] overflow-y-auto">
    @if (cartItems.length === 0) {
    <!-- Empty Cart -->
    <div class="text-center py-12">
      <mat-icon class="!text-[100px] text-gray-300">shopping_cart</mat-icon>
      <h3 class="text-xl font-bold text-gray-600 mt-4 mb-2">Your cart is empty</h3>
      <p class="text-gray-500 mb-6">Add some products to get started!</p>
      <button mat-raised-button (click)="close()" class="!bg-gradient-to-r !from-[#FF6B35] !to-[#FF8C42] !text-white !font-bold !rounded-xl">
        Continue Shopping
      </button>
    </div>
    } @else {
    <!-- Cart Items List -->
    <div class="space-y-4">
      @for (item of cartItems; track item.id) {
      <div class="flex gap-4 p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all">
        <!-- Product Image -->
        <div class="w-24 h-24 bg-gradient-to-br from-orange-50 to-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
          <mat-icon class="!text-[40px] text-[#FF6B35]/40">{{ item.icon }}</mat-icon>
        </div>

        <!-- Product Details -->
        <div class="flex-1">
          <h4 class="font-bold text-gray-900 mb-1">{{ item.name }}</h4>
          <div class="flex items-center gap-2 mb-2">
            @if (item.discount) {
            <span class="text-lg font-bold text-[#FF6B35]">
              TZS {{ getDiscountedPrice(item) | number:'1.0-0' }}
            </span>
            <span class="text-sm text-gray-400 line-through">
              TZS {{ item.price | number:'1.0-0' }}
            </span>
            <span class="bg-red-100 text-red-600 px-2 py-0.5 rounded-full text-xs font-bold">
              -{{ item.discount }}%
            </span>
            } @else {
            <span class="text-lg font-bold text-gray-900">
              TZS {{ item.price | number:'1.0-0' }}
            </span>
            }
          </div>

          <!-- Quantity Controls -->
          <div class="flex items-center gap-3">
            <div class="flex items-center gap-2 bg-white border border-gray-300 rounded-lg">
              <button mat-icon-button (click)="updateQuantity(item, -1)" [disabled]="item.quantity <= 1" class="!text-gray-600">
                <mat-icon>remove</mat-icon>
              </button>
              <span class="font-bold text-gray-900 min-w-[30px] text-center">{{ item.quantity }}</span>
              <button mat-icon-button (click)="updateQuantity(item, 1)" class="!text-gray-600">
                <mat-icon>add</mat-icon>
              </button>
            </div>
            <span class="text-sm text-gray-600">×</span>
            <span class="font-bold text-gray-900">TZS {{ getItemTotal(item) | number:'1.0-0' }}</span>
          </div>
        </div>

        <!-- Remove Button -->
        <button mat-icon-button (click)="removeItem(item.id)" class="!text-red-500 hover:!bg-red-50">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      }
    </div>
    }
  </div>

  <!-- Footer with Totals -->
  @if (cartItems.length > 0) {
  <div class="border-t border-gray-200 p-6 bg-gray-50">
    <!-- Price Breakdown -->
    <div class="space-y-3 mb-6">
      <div class="flex justify-between text-gray-600">
        <span>Subtotal:</span>
        <span class="font-semibold">TZS {{ getCartSubtotal() | number:'1.0-0' }}</span>
      </div>
      <div class="flex justify-between text-gray-600">
        <span>Tax (18%):</span>
        <span class="font-semibold">TZS {{ getTax() | number:'1.0-0' }}</span>
      </div>
      <div class="h-px bg-gray-300"></div>
      <div class="flex justify-between text-xl font-black text-gray-900">
        <span>Total:</span>
        <span class="text-[#FF6B35]">TZS {{ getCartTotal() | number:'1.0-0' }}</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-3">
      <button mat-stroked-button (click)="close()" class="flex-1 !border-2 !border-gray-300 !text-gray-700 !font-bold !rounded-xl">
        Continue Shopping
      </button>
      <button mat-raised-button (click)="proceedToCheckout()" class="flex-1 !bg-gradient-to-r !from-[#FF6B35] !to-[#FF8C42] !text-white !font-bold !rounded-xl !shadow-lg hover:!shadow-xl">
        <mat-icon class="mr-2">payment</mat-icon>
        Proceed to Checkout
      </button>
    </div>
  </div>
  }
</div>